import i18n from '../../lib/i18n'

export const accountingSoftware = {
  ['datev-lodas']: {
    get label() {
      return i18n.t('frontend:onboarding.accountingSoftware.datev-lodas')
    },
  },
  ['datev-lug']: {
    get label() {
      return i18n.t('frontend:onboarding.accountingSoftware.datev-lug')
    },
  },
  ['agenda']: {
    get label() {
      return i18n.t('frontend:onboarding.accountingSoftware.agenda')
    },
  },
  ['addison']: {
    get label() {
      return i18n.t('frontend:onboarding.accountingSoftware.addison')
    },
  },
  ['misc']: {
    get label() {
      return i18n.t('frontend:onboarding.accountingSoftware.misc')
    },
  },
}
